import { type ProductUIViewHeaderBaseProps } from './product-ui-view-header-base'
import { ProductUIViewHeaderList } from './product-ui-view-header-list'

export function ProductUIViewHeaderBoard({
    fullWidth = true,
    ...rest
}: ProductUIViewHeaderBaseProps) {
    return <ProductUIViewHeaderList {...rest} fullWidth={fullWidth} />
}
